import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

class Postier{

    getEvents(token:string,client:string,site:string,setMesures, setErrors: Dispatch<SetStateAction<string[]>>){

        axios.get(`api-v0/${client.split(":")[3]}/${site.split(':')[0]}/events`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setMesures(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les évènements ne peuvent pas être récupérés"])
            localStorage.clear()
            // location.reload()
        })

    }

    createEvent(token: string, data: any, setPagina, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.post(`api-v0/event`, data, {headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
                setErrors((errors: string[]) => [...errors, "Évènement créé"])
                setPagina('main')
                location.reload()
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Erreur lors de la création de l'évènement"])
        })
    }

    getEventsTypes(token: string, database: string, setEventsTypes, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.post(`api-v0/eventstypes`, { database, apiId: localStorage.getItem('apiId') }, {headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
                res.data.length === 0 && setErrors((errors: string[]) => [...errors, "Aucun types évènements trouvés"])
                setEventsTypes(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les events types ne peuvent pas être récupérés"])
        })
    }

    getSousEvents(token: string, database: string, setEvents, setErrors: Dispatch<SetStateAction<string[]>>) {
        axios.get(`api-v0/sousevents/${localStorage.getItem('apiId')}/${database}`, {headers:{ Authorization: `Bearer ${token}` }})
        .then(res=>{
                res.data.length === 0 && setErrors((errors: string[]) => [...errors, "Aucun sous évènements trouvés"])
                setEvents(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les évènements ne peuvent pas être récupérés"])
        })
    }


}

export const postier = new Postier()